<div class="relative flex flex-col justify-center w-full h-screen  lg:flex-row dark:bg-gray-900 sm:p-0">
    <div class="flex flex-col items-center flex-1">
        <div class="pt-5 pr-[48px] w-full">
            <div class="w-fit ml-auto">
                <app-user-dropdown [showButtonBack]="false" [style.viewTransitionName]="'user-dropdown'" (signOutClicked)="onSignOut()"></app-user-dropdown>
            </div>
        </div>
        <div class="p-5 flex flex-col items-center justify-center flex-1 max-w-4xl 2xl:w-5/7 xl:w-4/6 lg:w-4/5 md:w-4/5 max-md:w-4/5">
            <ccrr-list class="w-full max-h-4/5"></ccrr-list>
        </div>
    </div>
    
    <div class="bg-cover items-center hidden w-full h-full lg:w-1/2 bg-brand-950 dark:bg-white/5 lg:grid relative bg-[url(/assets/images/irrigation-system.jpg)]">
    
    </div>
</div>